var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Training",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.75,
    height: 20,
    viewBox: "0 0 18.75 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M249.375,19.414V14.688a.586.586,0,0,0-.586-.586H240V20h8.789A.586.586,0,0,0,249.375,19.414Zm-4.688-2.383a.586.586,0,1,1,.586-.586A.586.586,0,0,1,244.688,17.031Zm2.344-8.2a.586.586,0,1,0,1.172,0V7.07h.586a.586.586,0,0,0,.586-.586V.586A.586.586,0,0,0,248.789,0H248.1a4.521,4.521,0,0,0-2.243.615V7.93a3.5,3.5,0,0,1,1.172-.67ZM241.758,7.07h.687a3.429,3.429,0,0,1,2.243.86V.615A4.522,4.522,0,0,0,242.444,0h-.687a.586.586,0,0,0-.586.586v5.9A.586.586,0,0,0,241.758,7.07Zm0,0",
    transform: "translate(-230.625)",
    fill: "#7b818e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M.586,280.414H8.2v-.586a1.792,1.792,0,0,0-1.758-1.8H2.93a.586.586,0,0,1-.586-.586V273.93a.586.586,0,0,1,1.172,0v2.93h2.93a2.9,2.9,0,0,1,1.758.6V273.93a.586.586,0,0,1,.586-.586h4.042A2.934,2.934,0,0,0,9.961,271H9.295c-.014.013-.023.029-.037.042a1.683,1.683,0,0,1-.445.652l-1.128,1.131a1.689,1.689,0,0,1-1.239.519,1.723,1.723,0,0,1-1.28-.562l-1.131-1.128a1.551,1.551,0,0,1-.407-.615c-.012-.012-.021-.026-.033-.038H2.93A2.933,2.933,0,0,0,0,273.93v5.9A.586.586,0,0,0,.586,280.414Zm0,0",
    transform: "translate(0 -260.414)",
    fill: "#7b818e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M91.172,97.432v.013a.55.55,0,0,0,.176.41l1.172,1.172a.566.566,0,0,0,.82,0l1.172-1.172a.55.55,0,0,0,.176-.41v-.013a2.916,2.916,0,0,0,1.172-2.33V93.93a2.93,2.93,0,0,0-5.859,0V95.1A2.916,2.916,0,0,0,91.172,97.432Zm0,0",
    transform: "translate(-86.484 -87.445)",
    fill: "#7b818e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/Training.422eb0dbb505895b017b539995517c76.svg";
export { ForwardRef as ReactComponent };